import apiClient from './api'
class QuestionnaireService {
  async GetQuestionnaires(pageNo: any, pageSize: any, status: any) {
    try {
      const response = await apiClient.get(`/questionnaire/list/${status}?page=${pageNo}&resultsperpage=${pageSize}`)
      return response.data
    } catch (err) {
    }
  }
  async GetQuestion(questionId: any) {
    try {
      const response = await apiClient.get(`/questionnaire/question/${questionId}`)

      return response.data
    } catch (err) {
    }
  }
  // Like SetQuestionnaireStates, the step and question saves rethrow so callers can show the API's message
  // (e.g. "A practice-level step can't contain a File question")
  async PostQuestion(Id: any, stepId: any, postData: any) {
    const response = await apiClient.post(`/questionnaire/${Id}/step/${stepId}/questions`, postData)
    return response.data
  }
  async GetQuestionTypes() {
    try {
      const response = await apiClient.get(`/Questionnaire/QuestionTypes`)

      return response.data
    } catch (err) {
    }
  }
  async GetQuestions(Id: any, stepId: any) {
    try {
      const response = await apiClient.get(`/questionnaire/${Id}/step/${stepId || '1'}/questions`)
      return response.data
    } catch (err) {
    }
  }
  async CreateQuestionnaireStep(Id: any, name: any) {
    const response = await apiClient.post(`/questionnaire/${Id}/step`, name)
    return response.data
  }
  async CreateQuestionnaire(postData: any) {
    try {
      const response = await apiClient.post('/Questionnaire', postData)
      return response.data
    } catch (err) {
    }
  }
  async GetQuestionnaireSteps(Id: any) { 
    try {
      const response = await apiClient.get(`/questionnaire/${Id}`); 
      return response.data;
      
    } catch (err) {
    }
  }
  async GetQuestionnaireStates(Id: any) { 
    try {
      const response = await apiClient.get(`/questionnaire/${Id}/states`); 
      return response.data;
      
    } catch (err) {
    }
  }
  async SetQuestionnaireStates(Id: any, states: any, force?: boolean) {
    const response = await apiClient.post(`/questionnaire/${Id}/states${force ? '?force=true' : ''}`, states);
    return response.data;
  }
  async GetQuestionnaireInsuranceCompany(Id: any) { 
    try {
      const response = await apiClient.get(`/questionnaire/${Id}/insurance-company`); 
      return response.data;
      
    } catch (err) {
    }
  }
  async SetQuestionnaireInsuranceCompany(QuestionnaireId: any, InsuranceCompanyId: any) { 
    try {
      const response = await apiClient.post(`/questionnaire/${QuestionnaireId}/insurance-company/${InsuranceCompanyId}`); 
      return response.data;
      
    } catch (err) {
    }
  }
  async PublishQuestionnaire(Id: any) { 
    try {
      const response = await apiClient.put(`/questionnaire/${Id}/publish`); 
      return response.data;
    } catch (err) {
    }
  }
  async EditQuestion(Id: any, stepId: any, questionData: any) {
    const response = await apiClient.put(`/Questionnaire/${Id}/step/${stepId}/questions`,questionData);
    return response.data;
  }
  async EditStep(Id: any, stepId: any, questionData: any) {
    const response = await apiClient.put(`/Questionnaire/${Id}/step/${stepId}`,questionData);
    return response.data;
  }
  async DeleteQuestion(Id: any, stepId: any, questionId: any) { 
    try {
      const response = await apiClient.delete(`/Questionnaire/${Id}/step/${stepId}/question/${questionId}`); 
      return response.data;
    } catch (err) {
    }
  }
  async DeleteStep(Id: any, stepId: any) { 
    try {
      const response = await apiClient.delete(`/Questionnaire/${Id}/step/${stepId}`); 
      return response.data;
    } catch (err) {
    }
  }
  async GetInsuranceSteps() { 
    try {
      const response = await apiClient.get(`Credential/Questionnaire/steps`); 
      return response;
    } catch (err) {
    }
  }
  async GetInsuranceQuestions(id : any) { 
    try {
      const response = await apiClient.get(`Credential/Questionnaire/${id}/answers`); 
      return response;
    } catch (err) {
    }
  }
  
  async SubmitAnswers(payload : any, pageNumber : any) { 
    try {
      const response = await apiClient.post(`/Credential/Questionnaire/${pageNumber}/answers`,payload); 
      return response;
    } catch (err) {
    }
  }
  async GetAnswers( pageNumber : any) { 
    try {
      const response = await apiClient.get(`/Credential/Questionnaire/${pageNumber}/answers`); 
      return response;
    } catch (err) {
    }
  }
  async GetAdminCredentialRequestSteps(credentialRequestId : any) { 
    try {
      const response = await apiClient.get(`/Admin/credentialrequest/${credentialRequestId}/steps`); 
      return response;
    } catch (err) {
    }
  }
  async GetAdminCredentialRequestQuestions(credentialRequestId : any,stepNumber:any ) { 
    try {
      const response = await apiClient.get(`/Admin/credentialrequest/${credentialRequestId}/step/${stepNumber}`); 
      return response;
    } catch (err) {
    }
  }
  async postAdminComments(payload : any) { 
    try {
      const response = await apiClient.post(`/Admin/change-request`, payload); 
      return response;
    } catch (err) {
    }
  }
  async DeleteQuestionnaire(id : any) { 
    try {
      const response = await apiClient.delete(`/Questionnaire/${id}`); 
      return response;
    } catch (err) {
    }
  }
  async MoveQuestionToDifferentStep(id: any, sourcestepid: any, questionid: any, destinationstepid: any) {
    const response = await apiClient.put(`/Questionnaire/${id}/step/${sourcestepid}/question/${questionid}/moveto/${destinationstepid}`);
    return response;
  }
}
export default new QuestionnaireService()
